import { cn } from "@/lib/utils";

/** Same ring spinner used on the frontend-seo tracking page — kept visually
 * identical across both apps rather than using an icon-based spinner. */
export function Spinner({ className }: { className?: string }) {
  return <div className={cn("h-4 w-4 animate-spin rounded-full border-2 border-muted border-t-primary", className)} />;
}

/** Centered spinner + label for a page/section's initial data fetch. */
export function LoadingBlock({ label = "Loading…", className }: { label?: string; className?: string }) {
  return (
    <div className={cn("flex items-center justify-center gap-2 py-16 text-sm text-muted-foreground", className)}>
      <Spinner />
      {label}
    </div>
  );
}

/** Full-viewport spinner for standalone pages (auth callbacks, token exchange). */
export function FullPageSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-sm text-muted-foreground">
      <Spinner className="h-8 w-8" />
      {label}
    </div>
  );
}
